import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
const isAccessAllowed = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    
  /*  authenticated, grantedRoles,keycloak */
  const { authenticated } = authData;

    if (!authenticated) {
          return false;
    }
    return true;
};

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);




